module.exports = __webpack_public_path__ + "static/image1-da5bb280b49d4abe569c38d939c16040.jpg";